export const headerKeys = {
    EXPERIMENT: "X-Experiment-Data",
    APPLICATION_NAME: "X-Application-Name",
    REFERRAL_SEQUENCE_NUMBER: "X-Referral-Sequence-Number",
    SESSION_SEQUENCE_NUMBER: "X-Session-Sequence-Number",
    QUANTUM_METRIC_SESSION_ID: "X-QuantumMetric-Session-Id",
    QUANTUM_METRIC_USER_ID: "X-QuantumMetric-User-Id",
    TRANSACTION_ID: "X-Transaction-Id",
    EON: "X-Enterprise-Order-Number",
    LOG_ENABLED: "log-enabled",
    PAGE_NAME_TO_LOG: "X-Page-Name-To-Log",
    DEVICE_ID: "X-Device-Id",
    AWS_WAF_TOKEN: "x-aws-waf-token",
};
